import { Action, createReducer, on } from '@ngrx/store';
import { IUserLockedUpdateResponse, IUserLockedUpdateRequest } from '../models/lock.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadLockedRequest, loadLockedResponse, loadLockedFailure } from '../actions/locked.actions';

export const lockFeatureKey = 'lock';

export interface LockState {
  lockedRequest: IUserLockedUpdateRequest;
  lockedResponse: IUserLockedUpdateResponse;
  lockedFailure: IGenericError<ErrorResponse>;
}

export const initialState: LockState = {
  lockedRequest: undefined,
  lockedResponse: undefined,
  lockedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadLockedRequest, (state, action) => ({
    ...state,
    lockedRequest: action.request
  })),
  on(loadLockedResponse, (state, action) => ({
    ...state,
    lockedResponse: action.response
  })),
  on(loadLockedFailure, (state, action) => ({
    ...state,
    lockedFailure: action.error
  }))
);

export const getUserLockedRequest = (state: LockState) => state.lockedRequest;
export const getUserLockedResponse = (state: LockState) => {
  return state.lockedResponse;
};
export const getUserLockedFailure = (state: LockState) => state.lockedFailure;
